import React from 'react';

import AppModal from '../../../ui-components/AppModal';
import CountryForm from './CountryForm';

interface CountryFormModalProps {
  isOpen: boolean;
  mode: 'create' | 'edit';
  countryId?: string;
  onClose: () => void;
  onSuccess?: () => void;
}

const CountryFormModal: React.FC<CountryFormModalProps> = ({
  isOpen,
  mode,
  countryId,
  onClose,
  onSuccess,
}) => {
  return (
    <AppModal
      isOpen={isOpen}
      title={mode === 'edit' ? 'Edit Country' : 'Add Country'}
      description={
        mode === 'create'
          ? 'Create a new Country'
          : 'Update existing Country information'
      }
      onClose={onClose}
      hideFooter
      variant="form"
      maxWidth="max-w-3xl"
      closeOnOverlayClick
    >
      <CountryForm
        embedded
        countryId={countryId}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    </AppModal>
  );
};

export default CountryFormModal;
